import * as types from '../types';
import { IFinanceChargesApi } from '../contracts';
import { HttpApi } from './HttpApi';
import { compactReportParams } from './reports';

export class FinanceChargesHttpApi extends HttpApi implements IFinanceChargesApi {
  async previewFinanceCharges(query?: types.FinanceChargePreviewQuery): Promise<types.FinanceChargePreview> {
    // A blank asOfDate is not sent, so the server uses today.
    const response = await this.http.get<types.APIResponse<types.FinanceChargePreview>>('/finance-charges/preview', {
      params: compactReportParams(query),
    });
    return response.data.data;
  }

  async assessFinanceCharges(data: types.AssessFinanceChargesRequest): Promise<types.AssessFinanceChargesResult> {
    const response = await this.http.post<types.APIResponse<types.AssessFinanceChargesResult>>('/finance-charges/assess', data);
    return response.data.data;
  }
}
